export default __webpack_public_path__ + "static/media/green-menu.fe1ad641.svg";